module.exports = __webpack_public_path__ + "static/media/svg-5.45e54af5.svg";